const prefix = 'addon-form-fields';

export const i18n = {
    productName: {
        id: `${prefix}.productName`,
        defaultMessage: 'Product Name',
    },
    type: {
        id: `${prefix}.type`,
        defaultMessage: 'Type',
    },
    quantity: {
        id: `${prefix}.quantity`,
        defaultMessage: 'Quantity',
    },
    quoteId: {
        id: `${prefix}.quoteId`,
        defaultMessage: 'Quote ID',
    },
    notes: {
        id: `${prefix}.notes`,
        defaultMessage: 'Notes',
    },
    startDate: {
        id: `${prefix}.startDate`,
        defaultMessage: 'Start Date',
    },
    finishDate: {
        id: `${prefix}.finishDate`,
        defaultMessage: 'End Date',
    },
} as const;
